module.exports = __webpack_public_path__ + "img/P150T_weapon_56.e0d088d4.png";